/** Status badge tones aligned with `productInvoiceLinkStatus.ts`. */

export type PurchasingStatusBadge = {
  label: string
  className: string
}

const LINKED_CLASS = 'bg-emerald-50 text-emerald-800 ring-emerald-200'
const IGNORED_CLASS = 'bg-gray-100 text-gray-700 ring-gray-200'
const AMBER_CLASS = 'bg-amber-50 text-amber-800 ring-amber-200'
const BADGE_BASE = 'inline-flex rounded-full px-2 py-0.5 text-[11px] font-medium ring-1'

export function purchasingMatchStatusBadge(status: string): PurchasingStatusBadge {
  switch (status) {
    case 'confirmed':
    case 'auto':
      return { label: status === 'auto' ? 'Auto-linked' : 'Confirmed', className: LINKED_CLASS }
    case 'rejected':
      return { label: 'Rejected', className: IGNORED_CLASS }
    case 'pending':
      return { label: 'Pending', className: AMBER_CLASS }
    case 'pack_drift':
      return { label: 'Pack drift', className: AMBER_CLASS }
    default:
      return { label: status, className: IGNORED_CLASS }
  }
}

export function purchasingProductStatusBadge(status: string): PurchasingStatusBadge {
  switch (status) {
    case 'active':
      return { label: 'Active', className: LINKED_CLASS }
    case 'merged':
      return { label: 'Merged', className: IGNORED_CLASS }
    case 'archived':
      return { label: 'Archived', className: IGNORED_CLASS }
    default:
      return { label: status, className: IGNORED_CLASS }
  }
}

export function purchasingBrandPolicyBadge(policy: string): PurchasingStatusBadge {
  switch (policy) {
    case 'required':
      return { label: 'Required', className: AMBER_CLASS }
    case 'preferred':
      return { label: 'Preferred', className: LINKED_CLASS }
    default:
      return { label: 'Agnostic', className: IGNORED_CLASS }
  }
}

export function renderPurchasingStatusBadge(badge: PurchasingStatusBadge): string {
  return `${BADGE_BASE} ${badge.className}`
}
